<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between">
            {{ title }}
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <v-card-text> </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn rounded @click="validateCashPayment" :loading="loading" size="small"
                >Oui, je suis sûr(e)</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { linkAccountingLineWithCashBox } from "../../services/reconciliationServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "close", "cancel"],
})
export class CashPayment extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: "" }) userId: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) accountingLine: any;
    @Prop({ default: null }) accountingLines: any;
    @Prop({ default: null }) actions: any;

    loading: boolean = false;

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Oui, je suis sûr";
            this.actions.action.function = this.validateCashPayment;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value);
    }

    get title() {
        let title = "";
        if (this.totalPersonalisedAmountSigned < 0) {
            title = "Êtes-vous sûr(e) d'avoir réglé en espèce un montant de ";
        } else {
            title = "Êtes-vous sûr(e) d'avoir été réglé en espèce un montant de ";
        }
        title += newCommonFormatCurrency(this.totalPersonalisedAmountSigned) + " ?";
        return title;
    }

    get accountingLines_() {
        if (this.accountingLines) {
            return this.accountingLines;
        }
        if (this.accountingLine) {
            return [
                {
                    id: this.accountingLine.id,
                    amountSigned: this.accountingLine.amountSigned,
                    stillOwe: this.accountingLine.amountSigned,
                    personalisedAmountSigned: this.accountingLine.amountSigned,
                },
            ];
        }
        debugger; // git-ignore
        return [];
    }

    async validateCashPayment() {
        this.loading = true;
        if (this.accountingLines_?.length) {
            const result = await linkAccountingLineWithCashBox(
                this.$apollo,
                this.companyId,
                this.accountingLines_,
            );
            this.$emit("added", result);
        }
        this.loading = false;
        this.$emit("close");
    }

    cancel() {
        this.$emit("cancel");
    }

    get totalPersonalisedAmountSigned() {
        let total = 0;
        for (const al of this.accountingLines_) {
            total += al.personalisedAmountSigned;
        }
        return total;
    }
}

export default toNative(CashPayment);
</script>
